define([
	"dojo/_base/declare",
	"dojo/dom-class",
	"dojo/query",
	"dijit/registry",
	"csi/heading/_base",
	"csi/heading/Attribute",
	"csi/html",
	"csi/locale",
	"csi/widget/CheckBox",
	"csi/xml"
], function(declare, domClass, query, registry, csiHeading, Attribute, html, locale, CheckBox, xml) {

	var LOCALE_TRUE = "BooleanTrue";
	var LOCALE_FALSE = "BooleanFalse";

	return declare(Attribute, {
		defaultValue: false,
		queryOps: csiHeading.QUERY_OPS[xml.ATTR_BOOLEAN],
		tagAction: "ActionBoolean",
		type: xml.ATTR_BOOLEAN,

		// in boolean map, if entry for the key does not exist, return false
		defaultContainerValue: false,

		/**
		 * @override
		 * Check for enabled checkbox rather than tab-stop
		 */
		canPasteToCell(ctx, refNode) {
			const cb = this.getCheckbox(refNode);
			return cb && !cb.get("disabled");
		},

		formatValue: function(/*Any*/value, /*String?*/fmt) {
			// summary: return localized value of true/false
			if (value === true || value === 'true') {
				return locale.resource(LOCALE_TRUE);
			} else if (value === false || value === 'false') {
				return locale.resource(LOCALE_FALSE);
			}

			return "";
		},

		getCheckbox: function(/*DOMNode*/refNode) {
			// summary: return checkbox in cell
			var a = query(".dijitCheckBox", refNode);
			return a[0] ? registry.byNode(a[0]) : null;
		},

		getClickNode: function(/*DOMNode*/refNode) {
			// summary: return node to which action is attached
			var cb = this.getCheckbox(refNode);
			return cb && cb.domNode;
		},

		/**
		 * @override
		 * set allow filtering by selection of existing vlaues to true for boolean attributes
		 */
		getQuerySpec: function(ctx, h, spec) {
			var qs = this.inherited(arguments);
			qs.allowFilteringBySelectionOfExistingValues = true;
			return qs;
		},

		isTabStop: function(/*Context*/ctx, /*Heading*/h) {
			// summary: already in edit mode, so skip over for inline editing - could eventually be tab stop if we focus on checkbox?
			return false;
		},

		toHtmlStatic: function(/*Context*/ctx, /*Heading*/h, /*DOMNode*/refNode, /*ActionData*/actionData) {
			// summary: render value for attribute in HTML and attach action to just widget; output nothing if there is no value
			var value = this._getValue(ctx, h);
			if (value == null) {
				return false;
			}

			if (ctx.bExcel) {
				// if exporting to Excel, just output X for true values; otherwise it will be assumed to be false
				if (value) {
					html.text(refNode, "X");
				}
			} else if (ctx.bPrint) {
				// printing the checkbox widget does not look good, so switching to simple DOM with material icon;
				// PhantomJS seems to have some issues with the check material icon, so needed to separate icon from container
				// to position it correctly.
				var span = html.create("span", {"class": "csi-print-checkbox"}, refNode);

				if (value) {
					html.create("span", {
						"class": html.CSS_MATERIAL_ICON,
						innerText: "check"
					}, span);
				}
			} else {
				var bEdit = actionData && !actionData.bTooltip;
				var w = new CheckBox({
					disabled: !bEdit,
					value: value,

					// attribute controller will handle scrolling into view after change; Dojo should not do it on focus
					// or else causes issues in frozen table view
					scrollOnFocus: false
				}).placeAt(refNode);

				if (bEdit) {
					actionData.setClickNode(w.domNode, true);

					if (refNode.tagName.toLowerCase() != "span") {
						csiHeading.addHeadingNodeEditableStyling(refNode);
					}

					if (actionData.cssEdit) {
						domClass.add(refNode, actionData.cssEdit);
					}
				}
			}

			return true;
		},

		toHtmlDynamic: function(/*Context*/ctx, /*Heading*/h, /*DOMNode*/refNode, /*Object*/params) {
			// summary: render checkbox
			if (params.value == null) {
				params.value = this._getValue(ctx, h) || false;
			}

			return new CheckBox(params);
		},

		_toSortValue: function(/*Any*/value) {
			// summary: convert boolean to number
			return value ? 1 : 0;
		}
	});
});